import { Component, Injectable, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { EleitorDTO } from 'src/app/models/eleitorDTO.model';
import { NewEleitorDTO } from 'src/app/models/newEleitorDTO.model';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { EleitorService } from 'src/app/services/eleitor.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ControlContainer, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Utils } from 'src/app/utils/utils';
import { Ufs } from 'src/app/models/enums/uf-enum';
import { Eleitor } from 'src/app/models/eleitor.model';
import { Page } from 'src/app/models/page.model';
import { sha256 } from 'js-sha256';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmaEleitorSemPlanoComponent } from 'src/app/pages/gestor/modals/confirma-eleitor-sem-plano/confirma-eleitor-sem-plano.component';


@Component({
  selector: 'app-eleitor',
  templateUrl: './eleitor.component.html',
  styleUrls: ['./eleitor.component.css']
})
@Injectable()
export class EleitorComponent implements OnInit {
  currentLocation: string;
  formCadastroEleitores: FormGroup;
  idEleicao: any;
  idGestor: number;
  token: any;
  eleitores: EleitorDTO[];
  editandoEleitor: boolean = false;
  idEleitorEditando: any;
  newEleitorDTO: NewEleitorDTO = new NewEleitorDTO();
  duplicados: any = [];
  retornoDuplicados: boolean = false;
  eleicao: any;
  ufs: any[] = [];
  validaSenha: boolean = false;
  validaLogin: boolean = false;
  validaEmail: boolean = true;
  validaConfirmaSenha: boolean = false;
  public checaValidacao: boolean = true;
  btOff: boolean = false;
  model: NewEleitorDTO = { login: '', email: '', senha: '',  auth1: '',  auth2: '', plano: '', agrupador: '', estado: null, eleicao: null, idGestor: null };
  public page:Page;
  randomSenha: string;
  carregandoEleitores: boolean;
  podeEditarEleitor: boolean;
  eleicaoTemPlanos: boolean = false;
  eleitorSemPlanoData: any; 

  constructor(
    protected formBuilder: FormBuilder,
    private eleicaoService: EleicaoService,
    private eleitorService: EleitorService,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    public utils: Utils,
    private modalService: BsModalService,
    private bsModalRef: BsModalRef,
  ) { }

  ngOnInit() {
    for (let item in Ufs) {
      if (isNaN(Number(item))) {
        this.ufs.push({ value: item, text: Ufs[item] });
      }
    }
    this.spinner.show();
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.eleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.podeEditarEleitor = !(this.eleicao.statusEleicao == 'EM_ANDAMENTO' || this.eleicao.statusEleicao == 'APURADA' || this.eleicao.statusEleicao == 'ENCERRADA');
    this.idGestor = JSON.parse(sessionStorage.getItem("infoGestor")).id;
    this.eleicaoTemPlanos = this.eleicao.temPlanos;
    this.token = sessionStorage.getItem("token");
    this.formCadastroEleitores = new FormGroup({
      loginEleitor: new FormControl(),
      emailEleitor: new FormControl(),
      senhaEleitor: new FormControl(),
      auth1: new FormControl(),
      auth2: new FormControl(),
      plano: new FormControl(),
      agrupador: new  FormControl(),
      estado: new FormControl({value: '', disabled: !this.podeEditarEleitor}),
      confirmarSenhaEleitor: new FormControl()
    }); 
    //this.formCadastroEleitores.get("estado").setValue("Não definido");
    this.validaFormulario();
    //this.buscarEleitoresPorEleicaoId();
    this.buscarEleitoresPorEleicaoIdPage(10,0,);
    this.spinner.hide();
  }

  envioEleitor() {
    this.validarLoginEleitor(this.formCadastroEleitores.get('loginEleitor').value);
    this.validarSenhaEleitor(this.formCadastroEleitores.get('senhaEleitor').value);
    this.validarEmailEleitor(this.formCadastroEleitores.get('emailEleitor').value);
    if (this.validaLogin == false || this.validaConfirmaSenha == false) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha o Login e Senha do eleitor.' });
    } else if (this.validaEmail == false) {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha um Email válido para o eleitor ou deixe a informação em branco.' });
    } else if (this.validarInformacoesAutenticacao(null) == false){
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha tadas Informações de Autenticação com valores válidos.' });
    }else {
       this.btOff = true;
      document.body.style.cursor = 'wait';
      this.newEleitorDTO.login = this.formCadastroEleitores.get("loginEleitor").value;
      this.newEleitorDTO.email = this.formCadastroEleitores.get("emailEleitor").value;
      this.newEleitorDTO.senha = sha256.update(this.formCadastroEleitores.get("senhaEleitor").value).hex();
      this.newEleitorDTO.auth1 = this.formCadastroEleitores.get("auth1").value;
      this.newEleitorDTO.auth2 = this.formCadastroEleitores.get("auth2").value;
      this.newEleitorDTO.plano = this.formCadastroEleitores.get("plano").value;
      this.newEleitorDTO.agrupador = this.formCadastroEleitores.get("agrupador").value;
      this.newEleitorDTO.estado = this.temEstado(this.formCadastroEleitores.get("estado").value);
      this.newEleitorDTO.eleicao = { "id": this.idEleicao };
      this.newEleitorDTO.idGestor = this.idGestor;
      if (this.eleicao.temPlanos && ((!this.newEleitorDTO.plano || this.newEleitorDTO.plano === '') || (this.newEleitorDTO.agrupador === null || this.newEleitorDTO.agrupador === ''))) {
        this.btOff = false;
        document.body.style.cursor = 'default';
        this.abrirModalEleitorSemPlano(this.idEleicao);
        return;
      }
      this.salvarEleitor();
    }
  }

  private salvarEleitor() {
    if (this.editandoEleitor == false) {
      this.insertEleitor(this.newEleitorDTO, this.token);
    } else {
      if (this.eleicao.statusEleicao == 'EM_ANDAMENTO' || this.eleicao.statusEleicao == 'APURADA' || this.eleicao.statusEleicao == 'ENCERRADA') {
        this.updateEleitorEleicaoIniciada(this.newEleitorDTO, this.idEleitorEditando, this.token);
      }
      else {
        this.updateEleitor(this.newEleitorDTO, this.idEleitorEditando, this.token);
      }
    }
  }

  abrirModalEleitorSemPlano(idEleicao: number) {
      this.eleitorSemPlanoData = {
        token: this.token,
        idEleicao: idEleicao,
        eleitor: this.newEleitorDTO,
        editandoEleitor: this.editandoEleitor,
        confirmarCallback: () => this.salvarEleitor() 
      };
      const initialState = {
        title: 'Eleitor inserido sem plano ou agrupador.',
        header: 'Confirme se deseja seguir com o cadastro ou voltar para inserir o plano ou agrupador.',
        eleitorSemPlanoData: this.eleitorSemPlanoData,
      };
      this.bsModalRef = this.modalService.show(ModalConfirmaEleitorSemPlanoComponent, { initialState, class: 'modal-lg' });
    }

  validarLoginEleitor(login: string) {
    const expressaoRegular = /[^A-Za-z0-9\@\.\_\-]/g;

    if (login == null || login == '') {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário cadastrar um login para o eleitor.' });
      this.validaLogin = false;
    } else if (expressaoRegular.test(login) == true) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Não é permitido o uso de espaços no login. Os únicos caracteres especiais permitidos são "@", "-", "_" e "."!' });
      this.validaLogin = false;
    } else {
      this.validaLogin = true;
    }
  }

  validarEmailEleitor(email: string) {
    const expressaoRegularEmail = /\S+@\S+\.\S+/;
    if(expressaoRegularEmail.test(email) == false && email != '' && email != null){
      this.validaEmail = false;
    }else{
      this.validaEmail = true;
    }
  }

  validarInformacoesAutenticacao(msg: Number){
    let a1 = this.utils.noWhitespaceValidatorString(this.formCadastroEleitores.get("auth1").value);
    let a2 = this.utils.noWhitespaceValidatorString(this.formCadastroEleitores.get("auth2").value);
    if(a1 && msg == 1){
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha o campo Informação Autenticação 1.' });
      return false;
    }
    if(a2 && msg == 2){
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha o campo Informação Autenticação 2.' });
      return false;
    }
    if((!a1 && !a2 && msg == null)){
      return true
    }
    return false
  }

  validarSenhaEleitor(senha: string) {
    if (senha == null || senha == '') {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário cadastrar uma senha.' });
      this.validaSenha = false;
    } else {
      this.validaSenha = true;
    }
  }

  validarConfirmaSenhaEleitor(confirmarSenha: string) {
    let senha = this.formCadastroEleitores.get("senhaEleitor").value;
    if (confirmarSenha == null || confirmarSenha == '') {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário corfirmar a senha antes de prosseguir.' });
      this.validaConfirmaSenha = false;
    } else if (senha != confirmarSenha) {
      this.formCadastroEleitores.get("senhaEleitor").setValue('');
      this.formCadastroEleitores.get("confirmarSenhaEleitor").setValue('');
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário que as senhas coincidam. Tente novamente!' });
      this.validaConfirmaSenha = false;
    } else {
      this.validaConfirmaSenha = true;
    }
  }

  editarEleitor(eleitor) {
    this.editandoEleitor = true;
    this.idEleitorEditando = eleitor.id;
    this.formCadastroEleitores.get("loginEleitor").setValue(eleitor.login);
    this.formCadastroEleitores.get("emailEleitor").setValue(eleitor.email);
    this.formCadastroEleitores.get("senhaEleitor").setValue("");
    this.formCadastroEleitores.get("auth1").setValue(eleitor.auth1);
    this.formCadastroEleitores.get("auth2").setValue(eleitor.auth2);
    this.formCadastroEleitores.get("plano").setValue(eleitor.plano);
    this.formCadastroEleitores.get("agrupador").setValue(eleitor.agrupador);
    this.formCadastroEleitores.get("estado").setValue(this.temEstado(eleitor.estado));
    this.validaConfirmaSenha = false;
  }

  public cancelarEdicao() {
    this.editandoEleitor = false;
    this.formCadastroEleitores.reset();
  }

  excluirEleitor(idEleitor) {
    this.btOff = true;
    document.body.style.cursor = 'wait';
    this.eleitorService.excluirEleitorEleicao(idEleitor, this.token).then(() => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.buscarEleitoresPorEleicaoIdPage(10,0,);
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Eleitor excluído da eleição com sucesso!' });
    }, err => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: err + '.' });
    });
  }

  validaFormulario() {
    if (this.eleicao.statusEleicao != 'EM_ANDAMENTO') {
      this.checaValidacao = true;
    } else {
      this.checaValidacao = false;
    }

  }

  temEstado(estado: any) {

    if (estado == null || estado == '') {
      estado = 'NAO_DECLARADO';
    } else if (estado == 'NAO_DECLARADO') {
      estado = null;
    }
    return estado
  }

  baixarTemplate() {
    let csvHeader = 'login;senha;plano;uf;email;autenticacao1;autenticacao2;agrupador'
    this.utils.baixarModeloCsv(csvHeader, "logins_eleitores")
  }

  public buscarEleitoresPorEleicaoId() {
    this.eleicaoService.findAllEleitoresByEleicaoId(this.idEleicao, this.token).then((res: EleitorDTO[]) => {
      if (res != null && res.length > 0) {
        this.eleitores = res;
      } else {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Ainda não existem eleitores cadastros para essa eleição' });

      }
    })
  }

  public buscarEleitoresPorEleicaoIdPage(linesPerPage: number, page: number) {
    this.carregandoEleitores = true;
    this.eleicaoService.findAllEleitoresByEleicaoIdPage(this.idEleicao,linesPerPage, page, '', this.token).then((res: any) => {
      if (res.content != null && res.content.length > 0) {
            this.page = res;
            this.eleitores = res.content;
        this.carregandoEleitores = false;

        } else {
        this.carregandoEleitores = false;

           // this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Ainda não existem eleitores cadastros para essa eleição' });
        }
    })
}
changePage(event){
 this.buscarEleitoresPorEleicaoIdPage(event.size,event.page)
}
  public filtrarEleitoresPorNome(){
    var eleitorBuscado = (<HTMLInputElement>document.getElementById("filtroEleitor")).value;
    this.eleicaoService.findAllEleitoresByEleicaoIdPage(this.idEleicao, 10, 0, eleitorBuscado, this.token).then((res: any) => {
      if (res.content != null && res.content.length > 0) {
            this.page = res;
            this.eleitores = res.content;
        } else {
          this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Ainda não existem eleitores com esse login cadastrado.' });
          this.buscarEleitoresPorEleicaoIdPage(10,0);
        }
    })
  }
  limparFiltro(){
    this.buscarEleitoresPorEleicaoIdPage(10,0);
    (<HTMLInputElement>document.getElementById("filtroEleitor")).value = '';
  }

  gerarSenha(){
    event.preventDefault();
    let senhaGerada = "";
    var caracterLiberado = "0123456789";
  
    for (var i = 0; i < 6; i++)
    senhaGerada += caracterLiberado.charAt(Math.floor(Math.random() * caracterLiberado.length));
  
    this.randomSenha = senhaGerada;

  }

  public insertEleitor(eleitor: NewEleitorDTO, token: any) {
    this.eleitorService.insertEleitor(eleitor, token).then((resp: any) => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.formCadastroEleitores.reset();
      this.randomSenha = '';
      this.buscarEleitoresPorEleicaoIdPage(10,0,);
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Eleitor enviado com sucesso!' });
    }, err => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: err.error.message });
      this.formCadastroEleitores.reset();
      this.randomSenha = '';
    });
  }

  public updateEleitor(eleitor: NewEleitorDTO, idEleitor: number, token: any) {
    //this.model = eleitor;
    this.eleitorService.updateEleitor(eleitor, idEleitor, token).then(() => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.formCadastroEleitores.reset();
      this.randomSenha = '';
      this.buscarEleitoresPorEleicaoIdPage(10,0,);
      this.cancelarEdicao();
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Eleitor editado com sucesso!' });
    }, error => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: 'Nao foi possível editar o eleitor' });
      this.formCadastroEleitores.reset();
      this.randomSenha = '';
    });
  }

  public updateEleitorEleicaoIniciada(eleitor: NewEleitorDTO, idEleitor: number, token: any) {
    //this.model = eleitor;
    this.eleitorService.updateEleitorEleicaoIniciada(eleitor, idEleitor, token).then(() => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.formCadastroEleitores.reset();
      this.randomSenha = '';
      this.buscarEleitoresPorEleicaoIdPage(10,0,);
      this.cancelarEdicao();
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Eleitor editado com sucesso!' });
    }, error => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: error});
      this.formCadastroEleitores.reset();
      this.randomSenha = '';
    });
  }

}
